module.exports = __webpack_public_path__ + "static/img/65-1.9a61b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/65-1.jpg
// module id = O4DL
// module chunks = 0